import React from "react";
import { productRibbon, productRibbonCopy } from "./ProductRibbon.css";

export type Props = {
  ribbonKey: string;
  text: string;
};

const colorMap: { [key: string]: string } = {
  comingSoon: "lightGrey",
  newIn: "lightGrey",
  lowStock: "lightGrey",
  moreStockComingSoon: "lightGrey",
  outOfStock: "lightGrey"
};

export const ProductRibbon: React.FC<Props> = ({ ribbonKey, text }) => {
  const ribbonColor = colorMap[ribbonKey] || "default";

  return (
    <div className={productRibbon[ribbonColor]}>
      <span className={productRibbonCopy}>{text}</span>
    </div>
  );
};
